module.exports = __webpack_public_path__ + "img/chatbotix.ffec390b.png";